var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTodOcompletedBd65F0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01495F7B-B89F-4A39-92BE-DC3EFC2E7BF7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C-Onboarding-3",
    transform: "translate(-129.000000, -3306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "onboarding-activity",
    transform: "translate(98.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(31.000000, 2990.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-TODOcompleted",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49971542,22 C6.27421742,22 5.2801366,21.0013855 5.2801366,19.768254 L9.7189528,19.768254 C9.71918042,21.0013855 8.72521343,22 7.49971542,22 Z M15,17.5304419 C14.9994308,18.3555435 14.3343199,18.4099093 13.5141719,18.4099093 L1.4850313,18.4099093 C0.664541833,18.4099093 0,18.3555435 0,17.5303274 L0,17.3881751 C0,16.7947291 0.346613546,16.2865516 0.844621514,16.0455107 L1.316107,11.9534231 C1.316107,8.95769405 3.42310757,6.45732357 6.22811611,5.86742568 L6.22811611,4.27879883 C6.22811611,3.57261528 6.79760956,3 7.50028458,3 C8.2026181,3 8.77211155,3.57261528 8.77211155,4.27879883 L8.77211155,5.86754013 C11.5771201,6.45732357 13.6841207,8.95746514 13.6841207,11.9535375 L14.1556061,16.0461974 C14.6536141,16.2875817 15,16.7948435 15,17.3882895 L15,17.5304419 Z",
    id: "icon",
    fill: "#BD65F0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#BD65F0",
    cx: 13,
    cy: 5,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3461378,3.29304369 L15.2176692,4.12184466 L13.2563802,5.98697321 L12.4975821,6.70688214 L11.74043,5.98685254 L10.7823308,5.07572816 L11.6539051,4.24688645 L12.4977457,5.04935436 L14.3461378,3.29304369 Z",
    id: "checkmark",
    stroke: "#FFFFFF",
    strokeWidth: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTodOcompletedBd65F0);
export default __webpack_public_path__ + "static/media/icon-TODOcompleted-bd65f0.c468b94a1f8f6a7f89a4c385680dbaa7.svg";
export { ForwardRef as ReactComponent };